import React, { useContext, useState, useRef, useEffect } from 'react'
import './CartItems.css'
import { ShopContext } from '../../Context/ShopContext'
import remove_btn from '../Assets/close 24x24.png'
import {Link} from 'react-router-dom'


const CartItems = () => {
    const {
        all_products, 
        cartItems, 
        removeFromCart, 
        decrementQuantity, 
        addToCart, 
        getTotalCartPrice, 
        getTotalCartCount
    } = useContext(ShopContext);

    // cartItems: { [lineKey]: { productId, quantity, size, color } }
    const lineKeys    = Object.keys(cartItems)
    const hasItems    = lineKeys.length > 0

    // Fetch flat shipping rate from site settings
    const [shipping, setShipping] = useState(0)

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/site-settings`)
            .then(r => r.json())
            .then(d => {
                if (d.success) setShipping(d.settings.shippingRate || 0)
            })
            .catch(console.error)
    }, [])

    //summary calculations
    const totalamount = getTotalCartPrice() > 0 ? getTotalCartPrice() + shipping : 0; // total price + shipping (if there are items in the cart)

    const LIGHT_COLORS = ['#FFFFFF','#FFFDD0','#F5F0DC','#FDD835','#C6EF3B','#D3D3D3']

    // ── Swipe-to-remove state (mobile only) ───────────────────────────────────
    // Tracks which lineKey is currently swiped open
    const [swipedKey,  setSwipedKey]  = useState(null)
    const touchStartX = useRef(0)
    const touchStartY = useRef(0)
    const SWIPE_THRESHOLD = 60   // px — must swipe at least this far to reveal button

    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX
        touchStartY.current = e.touches[0].clientY
    }

    const handleTouchEnd = (e, lineKey) => {
        const deltaX = touchStartX.current - e.changedTouches[0].clientX
        const deltaY = Math.abs(touchStartY.current - e.changedTouches[0].clientY)
        // Ignore vertical scrolling — only respond to mostly-horizontal swipes
        if (deltaY > 30) return
        if (deltaX > SWIPE_THRESHOLD) {
            // Swiped left far enough — reveal remove button
            setSwipedKey(lineKey)
        } else {
            // Not far enough — snap back
            setSwipedKey(null)
        }
    }

    // Dismiss swipe when tapping elsewhere
    const handleDismissSwipe = () => setSwipedKey(null)

    return (
        <div className='cart-items' onClick={handleDismissSwipe}>
            <div className="cart-header">
                <h2>Shopping Cart</h2>
                <span>{getTotalCartCount()} {getTotalCartCount() === 1 ? 'Item' : 'Items'}</span>
            </div>

            {/* column headers - desktop view */}
            <div className="cart-item-layout">
                <p>Product</p>
                <p>Quantity</p>
                <p>Price</p>
                <p>Total</p>
            </div>
            <hr />

            {!hasItems && (
                <p className="cart-empty">Your cart is empty.</p>
            )}

            {lineKeys.map(lineKey => {
                const line    = cartItems[lineKey]
                const product = all_products.find(p => p.id === Number(line.productId))
                if (!product) return null;

                const isLight = line.color && LIGHT_COLORS.includes(line.color.hex)
                const isSwiped  = swipedKey === lineKey
                const lineTotal = (product.price * line.quantity).toLocaleString()

                return (
                    <div key={lineKey} className="cart-row-wrap">


                        <div className="cart-items-format cart-item-layout cart-row-wrap">
                            {/* product item data- image,name,color,size */}
                            <div className="item-info">
                                <img
                                    src={product.images[0]}
                                    alt={product.name}
                                    className="product-icon-img"
                                />
                                <div className="item-data">
                                    <p>{product.name}</p>
                                    <div className="item-data-selected">
                                        {line.color && (
                                            <p className="item-selection-tag">
                                                <span
                                                    className="cart-color-dot"
                                                    style={{
                                                        background: line.color.hex,
                                                        border: isLight ? '1px solid #aaa' : 'none'
                                                    }}
                                                />
                                                {line.color.name}
                                            </p>
                                        )}
                                        {line.size && (
                                            <p className="item-selection-tag">Size: {line.size}</p>
                                        )}
                                        {!line.color && !line.size && (
                                            <p className="item-selection-tag item-no-selection">No size / color selected</p>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* quantity input (click to decrease) */}
                            <div className="item-quantity">
                                <button className="quantity-decrement" onClick={() => decrementQuantity(lineKey)}>-</button>
                                <span>{line.quantity}</span>
                                <button className="quantity-increment" onClick={() => addToCart(line.productId, line.size, line.color)}>+</button>
                            </div>

                            {/* unit price */}
                            <p className="item-price">Rs. {Number(product.price).toLocaleString()}</p>

                            {/* line total */}
                            <p className="item-total-price">Rs. {lineTotal}</p>

                            {/* remove button */}
                            <img src={remove_btn} alt="Remove" onClick={() => removeFromCart(lineKey)} className='cart-item-romve-icon'/>
                        </div>

                        {/* mobile row - swipe to remove */}
                        <div className="cart-row-mobile">
                            {/* swipeable content */}
                            <div
                                className={`cart-mobile-item ${isSwiped ? 'cart-mobile-item--swiped' : ''}`}
                                onTouchStart={handleTouchStart}
                                onTouchEnd={e => handleTouchEnd(e, lineKey)}
                                onClick={e => e.stopPropagation()}
                            >
                                {/* Left: image */}
                                <img src={product.images[0]} alt={product.name} className="product-icon-img" />

                                {/* Right: info + quantity + total */}
                                <div className="cart-mobile-details">
                                    <p className="cart-mobile-name">{product.name}</p>
                                    {/* Color + size tags */}
                                    <div className="item-data-selected">
                                        {line.color && (
                                            <p className="item-selection-tag">
                                                <span className="cart-color-dot" style={{ background: line.color.hex, border: isLight ? '1px solid #aaa' : 'none' }} />
                                                {line.color.name}
                                            </p>
                                        )}
                                        {line.size && <p className="item-selection-tag">Size: {line.size}</p>}
                                    </div>
                                    {/* Quantity + line total on same row */}
                                    <div className="cart-mobile-bottom">
                                        <div className="item-quantity">
                                            <button onClick={() => decrementQuantity(lineKey)}>-</button>
                                            <span>{line.quantity}</span>
                                            <button onClick={() => addToCart(line.productId, line.size, line.color)}>+</button>
                                        </div>
                                        <p className="cart-mobile-total">Rs. {lineTotal}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Remove button — revealed by swipe */}
                            <button
                                className={`cart-mobile-remove-btn ${isSwiped ? 'cart-mobile-remove-btn--visible' : ''}`}
                                onClick={() => { removeFromCart(lineKey); setSwipedKey(null) }}
                            >
                                Remove
                            </button>

                        </div>
                        
                        <hr />
                    </div>
                )
            })}

            {/* order summary */}
            <div className="cart-summary">
                <div className="summary-header">
                    <h3>Order Summary</h3>
                </div>
                <div className="order-summary-details">
                    <p className='label'>Order Total</p>
                    <p className='value'>Rs. {getTotalCartPrice().toLocaleString()}</p> {/*{totalprice} */}
                </div>
                <div className="order-summary-details">
                    <p className='label'>Discount</p>
                    <p className='value'>0%</p> {/*{discount} */}
                </div>
                <div className="order-summary-details">
                    <p className='label'>Shipping  ⓘ</p>
                    <p className='value'>Rs. {shipping.toLocaleString()}</p> {/*{shipping cost} */}
                </div>
                <p className="cart-shipping-note">ⓘ Final rate confirmed at checkout</p>
                <hr />
                <div className="order-summary-details total-amount">
                    <p className='label'>Total Amount</p>
                    <p className='value'>Rs. {totalamount.toLocaleString()}</p> {/*{totalprice + shipping - discount} */}
                </div>
                {!hasItems ? <button disabled>Checkout</button> : <Link to="/checkout"><button>Checkout</button></Link>}
            </div>
        </div>
    )
}

export default CartItems